@if (canEdit) {
  <app-select
    [control]="control"
    [label]="''"
    [choices]="options"
    [clearable]="clearable"
    [placeholder]="placeholder"
    (change)="onChange($event)"
  ></app-select>
} @else {
  <span class="text-sm text-gray-700 dark:text-gray-300">{{ displayLabel() }}</span>
}
